@if (editor !== null) {
  <div class="editor-container">
    <tiptap-editor class="editor" [editor]="editor"></tiptap-editor>
    <tiptap-bubble-menu [editor]="editor">
      <div class="editor-bubble-menu">
        <button mat-button type="button" (click)="toggleBoldOnSelection()">Bold</button>
        <button mat-button type="button" (click)="toggleItalicOnSelection()">Italic</button>
        <button mat-button type="button" (click)="toggleBulletList()">Bullet List</button>
        <button mat-button type="button" (click)="toggleOrderedList()">Ordered List</button>
      </div>
    </tiptap-bubble-menu>
  </div>
}
